import { AuthError } from '@infra/auth/AuthService';
import {
  canWriteEntity,
  type EntityWriteAction,
  type EntityWriteResource,
} from '@shared/access/entityWriteRoles';
import { canReadEntity } from '@shared/access/entityReadRoles';

let roleProvider: () => string | undefined = () => undefined;
/** A-25 : licence expirée / gel → aucune écriture métier. */
let readOnlyProvider: () => boolean = () => false;

export function setEntityWriteRoleProvider(provider: () => string | undefined): void {
  roleProvider = provider;
}

export function setEntityReadOnlyProvider(provider: () => boolean): void {
  readOnlyProvider = provider;
}

export function isEntityWriteFrozen(): boolean {
  return readOnlyProvider();
}

export function assertLicenceAllowsWrite(): void {
  if (readOnlyProvider()) {
    throw new AuthError('LICENCE_EXPIRED');
  }
}

export function assertCanWriteEntity(
  resource: EntityWriteResource,
  action: EntityWriteAction,
): void {
  assertLicenceAllowsWrite();
  const role = roleProvider();
  // Sans session : laisser passer uniquement en bootstrap (tests / seed hors UI).
  if (!role) return;
  if (!canWriteEntity(role, resource, action)) {
    throw new AuthError('INSUFFICIENT_ROLE');
  }
}

/** A-25 : garde lecture pour ressources sensibles. */
export function assertCanReadEntity(resource: EntityWriteResource): void {
  const role = roleProvider();
  if (!role) return;
  if (!canReadEntity(role, resource)) {
    throw new AuthError('INSUFFICIENT_ROLE');
  }
}
